export default {
  "Login for users": "ورود به حساب کاربری",
  Login: "ایمیل / تلفن",
  Password: "رمز عبور",
  Submit: "ورود",
  "Field required": "فیلد ضروری است",
  "Auth error 400": "نام کاربری یا رمز عبور اشتباه است",
  "Auth error network":
    "مشکل در اتصال. لطفاً اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.",
  "Auth error unknown": "خطا. لطفاً بعداً دوباره امتحان کنید.",
  "Login title": "ورود | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Not account yet": "حساب کاربری ندارید؟",
  "Not account yet about":
    "می‌توانید حساب کاربری ایجاد کنید یا با حالت نمایشی با قابلیت محدود وارد شوید",
  "Demo-mode": "حالت نمایشی",
  "Let register": "ثبت‌نام",
  "User Agreement Title":
    "توافق‌نامه کاربر | " + process.env.VUE_APP_INSTALL_NAME + "",
  "User Agreement": "توافق‌نامه کاربر",
  "Privacy policy": "سیاست حفظ حریم خصوصی",
  "User Agreement About part 1": "با ادامه استفاده از سایت، شما شرایط ",
  "User Agreement About part 2": "توافق‌نامه کاربر را می‌پذیرید.",
  "User Agree": "می‌پذیرم",
  "Page not found": "صفحه یافت نشد",
  "Page not found about":
    "آدرس نادرست وارد شده یا این صفحه دیگر وجود ندارد. به صفحه اصلی بازگردید",
  "Back to main page": "بازگشت به صفحه اصلی",
  "Login for users 2":
    "به تمام امکانات پلتفرم دسترسی کامل پیدا کنید " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  Step: "مرحله",
  "Min 8": "حداقل ۸ کاراکتر",
  "1 char": "یک حرف",
  "1 num": "یک عدد",
  "Auth access 1": "با ",
  "Auth access 2": "پردازش داده‌های شخصی موافقم",
  "Auth access 3": "، شرایط ",
  "Auth access 4": "سیاست",
  "Auth access 5": "و",
  "Auth access 6": "توافق‌نامه کاربر را می‌پذیرم",
  "Auth access 7": "دریافت مواد تبلیغاتی و اطلاعاتی",
  "Have account?": "حساب کاربری دارید؟",
  "To next": "بعدی",
  "Reg for users 1": "ایجاد حساب کاربری",
  "Reg for users 2": "درباره خودتان بگویید",
  "Reg for users 3": "پایان ثبت‌نام",
  "Your last_name": "نام خانوادگی شما",
  "Your first_name": "نام شما",
  "Your middle_name": "نام میانگینتان.",
  "Your company": "محل کار",
  "Your position_in_the_company": "تخصص شما",
  Back: "بازگشت",
  "Min 2": "حداقل ۲ کاراکتر",
  Promo: "کد تخفیف (در صورت وجود)",
  invitation_1: "از آشنایان / همکاران",
  invitation_2: "ایمیل",
  invitation_3: "جستجو در یاندکس یا گوگل",
  invitation_4: "منبع دیگر",
  invitation_5: "شبکه‌های اجتماعی",
  "Where know about platform?": "از کجا با پلتفرم آشنا شدید؟",
  "Reg finish": "ثبت‌نام",
  regErrorText: "ثبت‌نام کاربر ناموفق بود. اطلاعات را بررسی کنید",
  "Auth banner text": "برای دسترسی کامل به امکانات پلتفرم وارد شوید",
  "Auth banner text 2": "برای افزایش تعداد مطالعات برای پردازش وارد شوید",
  "Auth banner text 3": "پردازش رایگان ۱۰ مورد از مطالعات خود را دریافت کنید",
  "Reg error":
    "متأسفانه به دلیل خطای فنی ثبت‌نام انجام نشد. لطفاً بعداً دوباره تلاش کنید",
  "Reg error 400": "آدرس ایمیل قبلاً استفاده شده است",
  "Rem password": "ایمیلی را که با آن ثبت‌نام کرده‌اید وارد کنید",
  Phone: "تلفن",
  "Not valid phone": "فرمت شماره تلفن نامعتبر است",
  emailVerify: {
    title: "تأیید ایمیل",
    desc1: "ایمیلی به آدرس ",
    desc2:
      " ارسال شده است. لطفاً بر روی لینک موجود در ایمیل کلیک کنید تا حساب کاربری شما فعال شود و به سرویس دسترسی پیدا کنید.",
  },
};
